// Single React Query client for the TG host app. Extracted from App.js so
// non-render code (AuthContext logout, etc.) can reach the same instance
// without importing App.js — that would create a circular dep since App.js
// already imports AuthContext. Note: TG host runs react-query v3 (the CRM
// module runs its own @tanstack/react-query v5 client separately).
import { QueryClient } from "react-query";

export const tgQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
